<template>
  <v-app-bar id="app-bar" absolute app color="transparent" flat height="75">
    <v-btn class="mr-3" elevation="1" fab small @click="setDrawer(!drawer)">
      <v-icon v-if="value">
        mdi-view-quilt
      </v-icon>

      <v-icon v-else>
        mdi-dots-vertical
      </v-icon>
    </v-btn>

    <v-toolbar-title
      class="hidden-sm-and-down font-weight-light"
      v-text="$route.name"
    />

    <v-spacer />

    <v-text-field
      :label="$t('search')"
      v-model="search_term"
      color="secondary"
      hide-details
      :loading="loading"
      @keyup.enter="search()"
    >
      <template v-if="$vuetify.breakpoint.mdAndUp" v-slot:append-outer>
        <v-btn class="mt-n2" elevation="1" fab small @click="search()">
          <v-icon>mdi-magnify</v-icon>
        </v-btn>
      </template>
    </v-text-field>


    <v-spacer />

    <v-icon>account_circle</v-icon>  <b class="ml-2">{{user && user.name}}</b>

<!--    <v-btn class="ml-2" min-width="0" text to="/">-->
<!--      <v-icon>mdi-view-dashboard</v-icon>-->
<!--    </v-btn>-->

<!--    <v-menu-->
<!--      bottom-->
<!--      left-->
<!--      offset-y-->
<!--      origin="top right"-->
<!--      transition="scale-transition"-->
<!--    >-->
<!--      <template v-slot:activator="{ attrs, on }">-->
<!--        <v-btn class="ml-2" min-width="0" text v-bind="attrs" v-on="on">-->
<!--          <v-badge color="red" overlap bordered>-->
<!--            <template v-slot:badge>-->
<!--              <span>5</span>-->
<!--            </template>-->

<!--            <v-icon>mdi-bell</v-icon>-->
<!--          </v-badge>-->
<!--        </v-btn>-->
<!--      </template>-->

<!--      <v-list :tile="false" nav>-->
<!--        <div>-->
<!--          <app-bar-item v-for="(n, i) in notifications" :key="`item-${i}`">-->
<!--            <v-list-item-title v-text="n" />-->
<!--          </app-bar-item>-->
<!--        </div>-->
<!--      </v-list>-->
<!--    </v-menu>-->

    <v-tooltip bottom>
      <template v-slot:activator="{ on }">
        <v-btn class="ml-2" min-width="0" text @click="logout"  v-on="on">
          <v-icon dark>mdi-power</v-icon>
        </v-btn>
      </template>
      <span>Logout</span>
    </v-tooltip>

  </v-app-bar>
</template>

<script>
// Components
// import { VHover, VListItem } from "vuetify/lib";

// Utilities
import { mapState, mapMutations, mapActions } from "vuex";

import searchAPI from '../../../../api/search_api';

export default {
  name: "DashboardCoreAppBar",

  components: {
    // AppBarItem: {
    //   render(h) {
    //     return h(VHover, {
    //       scopedSlots: {
    //         default: ({ hover }) => {
    //           return h(
    //             VListItem,
    //             {
    //               attrs: this.$attrs,
    //               class: {
    //                 "black--text": !hover,
    //                 "white--text secondary elevation-12": hover
    //               },
    //               props: {
    //                 activeClass: "",
    //                 dark: hover,
    //                 link: true,
    //                 ...this.$attrs
    //               }
    //             },
    //             this.$slots.default
    //           );
    //         }
    //       }
    //     });
    //   }
    // }
  },

  props: {
    value: {
      type: Boolean,
      default: false
    }
  },

  data: () => ({
    search_term: '',
    loading: false,
    notifications: [
      "Mike John Responded to your email",
      "You have 5 new tasks",
      "You're now friends with Andrew",
      "Another Notification",
      "Another one"
    ]
  }),

  computed: {
    ...mapState(["drawer", "user"])
  },

  methods: {
    ...mapMutations({
      setDrawer: "SET_DRAWER",
    }),
    ...mapActions({
      logout: 'LOG_OUT',
      showSnackbar: "SHOW_SNACKBAR"
    }),
    search() {
      this.loading = true;
      if(this.search_term) {
        searchAPI.search({q: this.search_term}).then(({data}) => {
          if(data && data.Items && data.Items.length > 0) {
            this.search_term = ''
            this.$router.push("/bookings/" + data.Items[0].id)
          }else {
            // this.snackbar_text = "No Booking found with: " + this.search_term
            this.showSnackbar({text: "No Booking found with: " + this.search_term, show: true, color: 'error'})
          }
          this.loading = false;
        })
      }
    }
  }
};
</script>
